import { SelectProps } from '@mui/material/Select'
import { brandedTokens } from '@/theme/tokens'

export const selectedMenuItemProps: SelectProps['MenuProps'] = {
    PaperProps: {
        sx: {
            '& .MuiMenuItem-root': {
                '&.Mui-selected': {
                    backgroundColor: brandedTokens.variables.secondaryScale[20],
                },

                '&:hover': {
                    backgroundColor: brandedTokens.variables.secondaryScale[10],
                },

                '&.Mui-selected:not([data-value=""])::after': {
                    content: '"✓"',
                    position: 'absolute',
                    right: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'primary.main',
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
            },
        },
    },
}
